var _excluded = ["size", "label", "isDisabled", "onChange", "isChecked", "value", "isIndeterminate", "isViewMode", "isReadOnly", "isInvalid", "children", "autoFocus", "aria-label", "aria-required"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Group } from '../../../containers';
import { Icon } from '../../../foundations/Icon';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Checkbox = forwardRef((_ref, ref) => {
  var _ref2;

  var {
    size = 'large',
    label,
    isDisabled,
    onChange,
    isChecked,
    value,
    isIndeterminate,
    isViewMode,
    isReadOnly,
    isInvalid,
    children,
    autoFocus,
    'aria-label': ariaLabel,
    'aria-required': ariaRequired
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('Checkbox', {
    size
  });
  var isCheckedValue = isChecked !== null && isChecked !== void 0 ? isChecked : value;
  var labelText = children !== null && children !== void 0 ? children : label;
  var labelComponent = labelText ? /*#__PURE__*/_jsx(Box, {
    __css: styles['label'],
    "data-disabled": isDisabled || undefined,
    "data-readonly": isReadOnly || undefined,
    children: labelText
  }) : null;
  var innerIcon = isCheckedValue || isIndeterminate ? /*#__PURE__*/_jsx(Box, {
    __css: styles['innerIcon'],
    children: /*#__PURE__*/_jsx(Icon, {
      type: isIndeterminate ? 'remove' : size === 'small' ? 'checked-mini' : 'checked',
      size: "small",
      color: "inverted"
    })
  }) : null;
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    ref: ref,
    "data-component": "Checkbox",
    __css: styles['container'],
    as: "label",
    "aria-disabled": isDisabled,
    "data-readonly": isReadOnly || undefined,
    onClick: event => event.stopPropagation()
  }, rest), {}, {
    children: /*#__PURE__*/_jsxs(Group, {
      spacing: "xs",
      alignItems: "flex-start",
      children: [/*#__PURE__*/_jsxs(Box, {
        __css: styles['checkboxContainer'],
        "data-with-label": Boolean(labelComponent),
        children: [/*#__PURE__*/_jsx(Box, {
          as: "input",
          __css: styles['checkbox'] // ts-ignore is used due to `type` issues with `<Box/>`.
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          ,
          type: "checkbox",
          disabled: isDisabled,
          checked: isCheckedValue,
          "aria-label": (_ref2 = ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : label) !== null && _ref2 !== void 0 ? _ref2 : 'checkbox',
          onChange: !isDisabled && !isReadOnly ? onChange : undefined,
          "data-checked": isIndeterminate ? 'mixed' : isCheckedValue || undefined,
          "data-testid": "checkbox-input",
          "aria-disabled": isDisabled,
          "aria-invalid": isInvalid,
          "data-readonly": isReadOnly || undefined,
          autoFocus: autoFocus,
          "aria-required": ariaRequired
        }), innerIcon]
      }), labelComponent]
    })
  }));
});
Checkbox.displayName = 'Checkbox';
//# sourceMappingURL=Checkbox.js.map